import React from 'react'
import { SignUp, ClerkLoaded, ClerkLoading } from '@clerk/react'
import { Box, Typography, CircularProgress } from '@mui/material'

export default function SignupPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f8fafc',
        py: 3,
      }}
    >
      <ClerkLoading>
        <Box sx={{ textAlign: 'center', px: 2 }}>
          <CircularProgress sx={{ color: '#1a365d' }} />
          <Typography sx={{ mt: 2, color: '#475569' }}>Loading sign-up…</Typography>
        </Box>
      </ClerkLoading>
      <ClerkLoaded>
        <SignUp
          routing="hash"
          signInUrl="/login"
          forceRedirectUrl="/dashboard"
        />
      </ClerkLoaded>
    </Box>
  )
}
